export default __webpack_public_path__ + "static/media/Interactive Map.08649c45.svg";